import { useToast } from '@/hooks/use-toast'
import { useWallet } from '@/hooks/use-wallet'
import { copyToClipBoard } from '@/utils/common'

export const useCommon = () => {
  const { toast } = useToast()
  const { disconnectWallet: disconnect, wallets } = useWallet()

  const copyToClipboard = async (content: string, successMessage?: string): Promise<boolean> => {
    const isCopied = await copyToClipBoard(content)
    if (isCopied) {
      toast({
        title: successMessage || 'Copied',
        description: 'Content has been copied to your clipboard.',
      })
      return true
    } else {
      toast({
        title: 'Copy Failed',
        description: 'Failed to copy. Please try again.',
        variant: 'destructive',
      })
    }
    return false
  }

  const disconnectWallet = async (networkId: string) => {
    try {
      await disconnect(networkId)
      toast({
        title: 'Wallet Disconnected',
        description: `Your ${networkId} wallet has been successfully disconnected.`,
      })

      return Object.keys(wallets).length <= 1
    } catch (error) {
      console.error(`Failed to disconnect ${networkId} wallet:`, error)
      toast({
        title: 'Disconnection Failed',
        description: `There was an error disconnecting your ${networkId} wallet. Please try again.`,
        variant: 'destructive',
      })
    }
    return false
  }

  return {
    copyToClipboard,
    disconnectWallet,
  }
}
